import React, { useState } from 'react';
import axios from 'axios';
import { API_URL, setApiToken } from './config';
import './Login.css';

// Configure axios for CORS - enable credentials for session support
axios.defaults.withCredentials = true;

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { data } = await axios.post(`${API_URL}/auth/token/`, {
        username,
        password,
      });

      const expirationTime = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem('api_username', username);
      localStorage.setItem('api_token', data.token);
      localStorage.setItem('api_session_expires', expirationTime.toString());
      localStorage.removeItem('api_password');

      setApiToken(data.token);
      onLogin(username);
    } catch (err) {
      // 401 or 403 from login endpoint both mean invalid/missing credentials (backend uses 403 to avoid browser popup)
      if (
        err.response &&
        (err.response.status === 400 || err.response.status === 401 || err.response.status === 403)
      ) {
        setError('Invalid username or password');
      } else {
        setError('Login error: ' + (err.message || 'Unknown error'));
      }
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Optie Portfolio API</h1>
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          {error && <div className="login-error">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;

